module.exports = __webpack_public_path__ + "img/audio-play1.96b7ded2.png";